import { HighlightedText } from "shared/components/organisms/AppNotification/components/atoms/HighlightedText";
import { IllustrationContainer } from "shared/components/organisms/AppNotification/components/atoms/IllustrationContainer";
import { NotificationContainer } from "shared/components/organisms/AppNotification/components/atoms/NotificationContainer";
import { NotificationFooterContainer } from "shared/components/organisms/AppNotification/components/atoms/NotificationFooterContainer";
import { NotificationFooterDot } from "shared/components/organisms/AppNotification/components/atoms/NotificationFooterDot";
import { NotificationFooterImage } from "shared/components/organisms/AppNotification/components/atoms/NotificationFooterImage";
import { NotificationFooterText } from "shared/components/organisms/AppNotification/components/atoms/NotificationFooterText";
import { NotificationText } from "shared/components/organisms/AppNotification/components/atoms/NotificationText";
import { NotificationTextContainer } from "shared/components/organisms/AppNotification/components/atoms/NotificationTextContainer";
import { NotificationTicket } from "shared/components/organisms/AppNotification/components/atoms/NotificationTicket";
import { NotificationTicketDivider } from "shared/components/organisms/AppNotification/components/atoms/NotificationTicketDivider";
import { NotificationTicketTextContent } from "shared/components/organisms/AppNotification/components/atoms/NotificationTicketTextContainer";
import { NotificationTitle } from "shared/components/organisms/AppNotification/components/atoms/NotificationTitle";
import { NotificationTitleWrapper } from "shared/components/organisms/AppNotification/components/atoms/NotificationTitleWrapper";
import { UserPhoto } from "shared/components/organisms/AppNotification/components/atoms/UserPhoto";

export const Notification = {
  UserPhoto,
  Container: NotificationContainer,
  IllustrationContainer,
  Title: {
    Container: NotificationTitleWrapper,
    Text: NotificationTitle,
    Highlight: HighlightedText,
  },
  Content: {
    Container: NotificationTextContainer,
    TicketContainer: NotificationTicketTextContent,
    Text: NotificationText,
    Ticket: NotificationTicket,
    TicketDivider: NotificationTicketDivider,
  },
  Footer: {
    Container: NotificationFooterContainer,
    Text: NotificationFooterText,
    Dot: NotificationFooterDot,
    Image: NotificationFooterImage,
  },
};
